import moment from "moment";
import { useState } from "react";
import { FiBookOpen, FiCamera, FiClock, FiEdit2, FiList, FiTrash } from "react-icons/fi";
import { Link } from "react-router-dom";

export default function ContentList({
  title,
  babs,
  imgSrc,
  createdTime,
  id,
  onDelete,
  editLink,
  detailLink,
  countDisplay,
  countLabel = "Ring",
  showCreatedTime = true,
  manageLabel = "Kelola Ring",
  onChangeCover,
  hideEdit = false,
}) {
  const editHref = editLink || `/content/edit/${id}`;
  const detailHref = detailLink || `/content/${id}/bab`;
  const cover =
    imgSrc && imgSrc !== "null"
      ? process.env.REACT_APP_BASE_URL + imgSrc
      : `${process.env.REACT_APP_BASE_URL}/no-image.png`;
  const countText = countDisplay || `${babs} ${countLabel}`;
  const [hover, setHover] = useState(false);
  return (
    <div
      className={`border border-white-200 rounded-sm p-3 lg:p-4 flex items-center gap-4 mt-4 transition-colors ${
        hover ? "bg-white-200 border-white-300" : "bg-white-100"
      }`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <img
        src={cover}
        alt={"Cover " + title}
        className="w-20 lg:w-24 h-20 lg:h-24 object-cover rounded bg-white-200"
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = `${process.env.REACT_APP_BASE_URL}/no-image.png`;
        }}
      />
      <div className="flex-1">
        <h3 className="font-bold text-base md:text-lg">{title}</h3>
        <div className="flex flex-wrap mt-1">
          {showCreatedTime ? (
            <span className="flex items-center text-sm mr-5">
              <FiClock className="mr-2" /> {moment(createdTime).format("DD/MM/YYYY")}
            </span>
          ) : null}
          <span className="flex items-center text-sm mr-5">
            <FiBookOpen className="mr-2" /> {countText}
          </span>
        </div>
      </div>
      <div className="flex items-center flex-wrap gap-2">
        {onChangeCover ? (
          <button
            type="button"
            onClick={() => onChangeCover(id)}
            className="p-1.5 rounded-sm border border-white-300 text-sm transition-colors hover:bg-primary-400 hover:border-primary-500 hover:text-white-100 flex items-center"
          >
            <FiCamera />
          </button>
        ) : null}
        {!hideEdit && (
          <Link
            to={editHref}
            className="p-1.5 rounded-sm border border-white-300 text-sm transition-colors hover:bg-yellow-200 hover:border-yellow-300 flex items-center"
          >
            <FiEdit2 />
          </Link>
        )}
        <Link
          to={detailHref}
          className="p-1.5 rounded-sm border border-white-300 text-sm transition-colors hover:bg-primary-500 hover:border-primary-600 hover:text-white-100 flex items-center"
        >
          <FiList />
        </Link>
        {onDelete ? (
          <button
            onClick={() => {
              onDelete(id);
            }}
            type="button"
            className="p-1.5 rounded-sm border border-white-300 text-sm transition-colors hover:bg-red-200 hover:border-red-300 hover:text-white-100 flex items-center"
          >
            <FiTrash />
          </button>
        ) : null}
      </div>
    </div>
  );
}
